/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:600px){.listing-card[_ngcontent-%COMP%]{max-height:375px;box-shadow:0 2px 10px 2px #c4c6c8}.listing-card[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{min-height:60px}.listing-card.selected[_ngcontent-%COMP%]{box-shadow:0 2px 10px 2px #004e9b}}"];
export { styles as styles };
